import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccountCommonModule } from '@inyova/account-common';
import { InyovaSharedModule } from '@inyova/inyova-shared';
import { WithdrawalModule } from '@inyova/withdrawal';
import { TranslateModule } from '@ngx-translate/core';

import { ReferralsComponent } from '@app/modules/general/pages/referrals/referrals.component';
import { ReferralsDialogShareComponent } from '@app/modules/general/pages/referrals-dialog-share/referrals-dialog-share.component';
import { VerifyEmailComponent } from '@app/modules/general/pages/verify-email/verify-email.component';
import { SharedModule } from '@shared/shared.module';

import { GeneralRoutingModule } from './general-routing.module';
import { CrossSellingComponent } from './pages/cross-selling/cross-selling.component';
import { ExitSurveyComponent } from './pages/exit-survey/exit-survey.component';
import * as fromFund from './pages/fund/components';
import { FundComponent } from './pages/fund/fund.component';
import * as fromFundWithdrawal from './pages/fund-withdraw/components';
import { FundWithdrawComponent } from './pages/fund-withdraw/fund-withdraw.component';
import { HelpComponent } from './pages/help/help.component';
import { SurveyComponent } from './pages/survey/survey.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    GeneralRoutingModule,
    WithdrawalModule,
    AccountCommonModule,
    InyovaSharedModule
  ],
  exports: [],
  declarations: [
    CrossSellingComponent,
    HelpComponent,
    SurveyComponent,
    ExitSurveyComponent,
    FundComponent,
    ...fromFund.components,
    FundWithdrawComponent,
    ...fromFundWithdrawal.components,
    ReferralsComponent,
    ReferralsDialogShareComponent,
    VerifyEmailComponent
  ],
  providers: []
})
export class GeneralModule {}
